import React, { useEffect, useState } from "react";
import {
  Paper,
  IconButton,
  Menu,
  MenuItem,
  Typography,
} from "@material-ui/core";
import { MoreVert as MoreIcon } from "@material-ui/icons";
import classnames from "classnames";
import {FaCircleExclamation} from "react-icons/fa6"

import apiService from "../../core/service/detail";
import { getMethod } from "../../core/service/common.api";
import { postMethod } from "../../core/service/common.api";
// styles
import useStyles from "./styles";

export default function Widget({
  children,
  title,
  noBodyPadding,
  bodyClass,
  disableWidgetMenu,
  header,
  ...props
}) {
  var classes = useStyles();
  console.log(props,"")

  // local
  var [moreButtonRef, setMoreButtonRef] = useState(null);
  var [isMoreMenuOpen, setMoreMenuOpen] = useState(false);

  useEffect(()=>{
    getDashboardCount()
  },[0]);

    const [contacts, setcontacts] = useState({});
  
   const getDashboardCount = async (id) => {
    try {
      var data = {
        apiUrl: apiService.getDashboardCount,
      };
      var resp = await postMethod(data);
      if (resp.status) {
        setcontacts(resp.data);
      } else {
        setcontacts({});
      }
    } catch (error) {}
  };
  return (
    <div className={classes.widgetWrapper}>
      <Paper className={classes.paper} classes={{ root: classes.widgetRoot }}>
        <div className={classes.widgetHeader}>
          {header ? (
            header
          ) : (
            <React.Fragment>
              <Typography variant="h5" color="textSecondary">
               <b className="text-dark"> {title}</b>
              </Typography>
              {/* {!disableWidgetMenu && (
                <IconButton
                  color="primary"
                  classes={{ root: classes.moreButton }}
                  aria-owns="widget-menu"
                  aria-haspopup="true"\
                  onClick={() => setMoreMenuOpen(true)}
                  buttonRef={setMoreButtonRef}
                >
                </IconButton>
              )} */}
               {/* <div className="dsh_exclamation">
                <FaCircleExclamation />
                <div className="dsh_details_box">
                  <div className="dsh_details_flx">
                    <span className="dsh_dt_lft">Today count</span>
                    <span className="dsh_dt_rgt">
                      20
                    </span>
                  </div>
                  <div className="dsh_details_flx">
                    <span className="dsh_dt_lft"> Last Month</span>
                    <span className="dsh_dt_rgt">
                     10
                    </span>
                  </div>
                  <div className="dsh_details_flx">
                    <span className="dsh_dt_lft">Last week</span>
                    <span className="dsh_dt_rgt">
                      30
                    </span>
                  </div>
                </div>
              </div> */}
            </React.Fragment>
          )}
        </div>
        <div
          className={classnames(classes.widgetBody, {
            [classes.noPadding]: noBodyPadding,
            [bodyClass]: bodyClass,
          })}
        >
          {children}
        </div>
      </Paper>
      {/* <Menu
        id="widget-menu"
        open={isMoreMenuOpen}
        anchorEl={moreButtonRef}
        onClose={() => setMoreMenuOpen(false)}
        disableAutoFocusItem
      >
        <MenuItem>
          <Typography>Edit</Typography>
        </MenuItem>
        <MenuItem>
          <Typography>Copy</Typography>
        </MenuItem>
        <MenuItem>
          <Typography>Delete</Typography>
        </MenuItem>
        <MenuItem>
          <Typography>Print</Typography>
        </MenuItem>
      </Menu> */}
    </div>
  );
}
